
import './Css/bootstrap.min.css';
import './App.css';
import Menu from './Components/Header/Menu';
import BackButton from './Components/Header/Back';
import HomePage from './pages/index'
import Footer from './Common/footer'
import LoginCustomer from './pages/loginCustomer';
import Service from './pages/Service';
import Tasks from './pages/tasks';
import Loader from 'react-loader-spinner';
import GuaranteeCardStatus from './pages/GuaranteeCardStatus';
import GuaranteeStatusResult from './pages/GuaranteeStatusResult';
import RegisterCustomer from "./pages/RegisterCustomer";
import ForgetPassword from './pages/ForgetPassword';
import Happycall from "./pages/Happycall";
import Profile from "./pages/Profile";
import LastRequest from "./pages/LastRequest";
import RequestPassword from "./pages/RequestPassword";
import ServiceInvoice from "./pages/ServiceInvoice";
import Complaint from './pages/Complaint';
import ComplaintList from './pages/ComplaintList';
import { checkSystemVersion } from './store/api/SystemSettingsAPI';
import { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import PrintViewer from "./pages/PrintViewer";
import NotificationArea from './Components/NotificationArea';
import CustomerProducts from "./pages/CustomerProducts";
import ModalDialog from "./Common/ModalDialog";
import MenuWide from "./Components/Header/MenuWide";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import ModalAboutUs from './pages/ModalAboutUs';
import Ticket from './pages/Ticket';
import NoticeBoard from './pages/NoticeBoard';
import { isMobileApp, isWebApp, setServerUrl } from './store/api/CommonFunctions';
import ServiceWithoutLogin from './pages/ServiceWithoutLogin';
const requireAuth = (setUser) => {
  const token = localStorage.getItem('token');
  if (token != null && token) {
    setUser(token);
  } else {
    setUser(null);
  }
}

function App() {

  const [pending, setPending] = useState(true);
  const [currentUser, setUser] = useState(null);
  const [menuWidth, setMenuWidth] = useState("0");
  const [service, setService] = useState(false);
  const [registerCustomer, setRegister] = useState(false);
  const [forgetPassword, setForgetPassword] = useState(false);
  const [showAboutUs, setModalAboutUs] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    // Update the document title using the browser API
    requireAuth(setUser);
    setPending(false);
    dispatch(checkSystemVersion());
    // getUrl();
  }, []);
  (function () {
    fetch('././config.json'
      , {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (myJson) {
        localStorage.setItem("AutoSendStaff", myJson.AUTO_SEND_STAFF)
        localStorage.setItem("ServerUrl", myJson.SERVER_URL);
        setServerUrl(myJson.SERVER_URL);
        if (myJson.RegisterCode && !localStorage.getItem("Company")) {
          fetch("https://Demo.bpro.ir/CompanyAPI/GetCompany?RegisterCode=" + myJson.RegisterCode,
            { method: "GET", cache: "no-cache" })
            .then(res => res.json())
            .then(res => {
              localStorage.setItem("Company", JSON.stringify(res))
            }
            )
            .catch(er => console.log("[GetCompany]", er))
        }
      });
  })();
  return (
    <div className="App">
      <Router>
        <ModalDialog />
        {currentUser &&
          <Fragment>

            <ModalAboutUs show={showAboutUs} setModalAboutUs={setModalAboutUs} />
            <div style={{ height: "20px" }} className="pageTitle">
              {isMobileApp() && <Menu setModalAboutUs={setModalAboutUs} />}
              {isWebApp() &&
                <Fragment><span style={{ fontSize: "30px", cursor: "pointer", position: "absolute", right: "15px", top: "6px" }} onClick={() => { setMenuWidth("250px") }}>&#9776;</span>
                  <MenuWide menuWidth={menuWidth} setMenuWidth={setMenuWidth} currentUser={currentUser} setModalAboutUs={setModalAboutUs} menuName="Main" />
                </Fragment>}
            </div>
            <BackButton />
            <Switch>
              <Route path="/service"><Service /> </Route>
              <Route path="/tasks"><Tasks /> </Route>
              <Route path="/GuaranteeCardStatus"><GuaranteeCardStatus /></Route>
              <Route path="/GuaranteeStatusResult"><GuaranteeStatusResult /></Route>
              <Route path="/Happycall/:serviceID/:serviceType"><Happycall /></Route>
              <Route path="/Profile"><Profile /></Route>
              <Route path="/LastRequest"><LastRequest /></Route>
              <Route path="/RequestPassword"><RequestPassword /></Route>
              <Route path="/ServiceInvoice/:serviceID/:serviceType"><ServiceInvoice /></Route>
              <Route path="/Complaint/:serviceID/:serviceType/:serviceNumber/:productSerial/:productID"><Complaint /></Route>
              <Route path="/ComplaintList"><ComplaintList /></Route>
              <Route path="/Ticket"><Ticket /></Route>
              <Route path="/NoticeBoard"><NoticeBoard /></Route>
              <Route path="/CustomerProducts"><CustomerProducts /></Route>
              <Route path="/PrintViewer/:reportName/:designMode"><PrintViewer /></Route>
              <Route path="/"><HomePage /> </Route>
            </Switch>
            <NotificationArea />
          </Fragment>
        }
        {pending &&
          <Loader type="BallTriangle" color="red" height={50} width={50} />}
        {!currentUser && !pending && registerCustomer && !forgetPassword && !service &&
          <Switch>
            <Route path="/RegisterCustomer"><RegisterCustomer setRegister={setRegister} /></Route>
          </Switch>
        }
        {!currentUser && !pending && !registerCustomer && forgetPassword && !service &&
          <Switch>
            <Route path="/ForgetPassword"><ForgetPassword setForgetPassword={setForgetPassword} /></Route>
          </Switch>
        }
        {!currentUser && !pending && !registerCustomer && !forgetPassword && service &&
          <Switch>
            <Route path="/ServiceWithoutLogin"><ServiceWithoutLogin setShowService={setService} /></Route>
          </Switch>
        }
        {!pending && !currentUser && !registerCustomer && !forgetPassword && !service &&
          <Fragment>
            <LoginCustomer setUser={setUser} setForgetPassword={setForgetPassword} setRegister={setRegister} setService={setService} />
          </Fragment>}
        <Footer />
      </Router>
    </div>
  );
}

export default App;
